// ShipOverlayContentView moved into Views/Ship/OverlayContentView.tsx. This thin re-export
// barrel keeps the original `./ShipOverlayContentView` import path working for external
// references (e.g. MenuShip/MenuSync/MenuNMEA, FocusView, CruiseCalendarView, and their
// tests, which mock this module) outside the Ship hub.

export { ShipOverlayContentView, ShipOverlayContentViewData, ShipViewOverlayContent } from "./Ship/OverlayContentView"
export type { ShipViewOverlayOptions } from "./Ship/OverlayContentView"
